export default "__VITE_ASSET__BGcPor54__"